import { createContext, Dispatch, SetStateAction } from 'react';
import { IQuestion, ISurvey, Option } from '../interfaces/question.type';

export type MyDispatch<T> = Dispatch<SetStateAction<T>>;

interface SurveyContextType {
	termsAccepted: boolean;
	setTermsAccepted: MyDispatch<boolean>;
	selectedOption: Option | null;
	setSelectedOption: MyDispatch<Option | null>;
	completed: boolean;
	setCompleted: MyDispatch<boolean>;
	response: string;
	setResponse: MyDispatch<string>;
	otherResponse: string;
	setOtherResponse: MyDispatch<string>;
	survey: ISurvey | null;
	setSurvey: MyDispatch<ISurvey | null>;
	currentQuestion: IQuestion | null;
	setCurrentQuestion: MyDispatch<IQuestion | null>;
	loading: boolean;
	setLoading: MyDispatch<boolean>;
}

export const SurveyContext = createContext<SurveyContextType>({} as SurveyContextType);
